import { da } from 'date-fns/locale';
import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';
import { cancella } from './std';

const {logger} = useBSSLogger();

const retrieveRubrica =  async (orderByContatto = true) => {

    let {data} = await getapiclient().post(`indirizzispe/grid`, {
        sort: [
            {field: "ragionesociale", dir: "asc"}
        ]
    })

    let {results = []} = data;

    logger.debug("rubrica utente da webservice", data);

    // if(orderByContatto){
    //     results = results.sort((a, b) => (a.ragsoc ?? "").localeCompare(b.ragsoc ?? "") )
    // }

    return results;
}

const creaContatto = async (dati) => {


    const {data} = await getapiclient().post(`indirizzispe/${(![null, undefined].includes(dati.id)) ? 'modify' : 'create'}`, {
        entity: JSON.stringify(dati),
        creapergruppo: dati.creapergruppo ?? false
    })

    logger.debug("contatto aggiunto in rubrica", data);

    return data;
}

const cancellaContatto = async (dati) => {
    
    const {data} = await getapiclient().post(`indirizzispe/cancellaperragsoc`, {
        ragsoc: JSON.stringify(dati),
        cancellapergruppo: dati.cancellapergruppo ?? false
    }) 

    const eliminato = data ?? {};

    logger.debug(`eliminati contatti per ragione sociale`, dati, eliminato)

    return eliminato; 
}

const cancellaIndirizzo = async (dati) => {
    const {data} = await cancella("indirizzispe", Array.isArray(dati) ? dati : [dati])

    logger.debug("indirizzo eliminato dalla rubrica", dati, data);

    return data;
}

export {retrieveRubrica, creaContatto, cancellaContatto, cancellaIndirizzo}